import { CompanyDetailAndJobGroups } from '@types';
import { CompanyDataProvider } from 'ogp/components/views/management/company/company-data-provider';
import { Page } from 'redesign/page/page';
import { Header } from 'redesign';
import { FormProvider, useForm } from 'react-hook-form';
import { settingsAlerts, useAlert } from 'shared/components/alerts';
import { routes } from 'ogp/Routes';
import { useNavigate } from 'react-router-dom';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useTranslation } from 'react-i18next';
import { SettingsEditToolbox } from './settings-edit-toolbox';
import { SettingsEdit } from './settings-edit';
import { useUpdateCompanySettings } from './hooks/use-update-settings';

export type CompanySettingsData = {
  requiresEmployeeContract: boolean;
  requiresEmployeeCertificates: boolean;
};

export const SettingsEditPageDataProvider = () => {
  return (
    <CompanyDataProvider>
      {(companyData) => <SettingsEditPage companyData={companyData} />}
    </CompanyDataProvider>
  );
};

const SettingsEditPage = (props: { companyData: CompanyDetailAndJobGroups }) => {
  const { t } = useTranslation('ogp-screen-specific');
  const { alertSuccess, alertError } = useAlert();
  const generatePath = useCompanyRelativePath();
  const navigate = useNavigate();

  const mutation = useUpdateCompanySettings();

  const formMethods = useForm<CompanySettingsData>({
    defaultValues: {
      requiresEmployeeContract: props.companyData.company.requiresEmployeeContract,
      requiresEmployeeCertificates: props.companyData.company.requiresEmployeeCertificates,
    },
  });

  const handleSubmit = () => {
    formMethods.handleSubmit((data: CompanySettingsData) =>
      mutation.mutate(data, {
        onSuccess: () => {
          alertSuccess(t(settingsAlerts.success.updated));
          navigate(generatePath(routes.Settings));
        },
        onError: (e) => alertError(e),
      })
    )();
  };

  return (
    <form>
      <FormProvider {...formMethods}>
        <Page
          toolbox={<SettingsEditToolbox handleSubmit={handleSubmit} />}
          header={<Header titleText={t('settings-edit-page.title')} />}
        >
          <SettingsEdit />
        </Page>
      </FormProvider>
    </form>
  );
};
